import {useEffect, useState} from 'react';
import {CurriculumTypeEnum, GradeService} from '@PikaDoApp/npm-pikado-logic';
import {
  Button,
  Col,
  Input,
  Modal,
  Row,
  Select,
  Switch,
  Typography,
  notification,
} from 'antd';
import {useHistory, useLocation} from 'react-router-dom';
import {Level, Program} from '../../graphql/API';
import {LevelUI} from '../Level/LevelTypes';
import {CurriculumUI} from './CurriculumTypes';
import {LevelsService} from '../Level/LevelsService';
import {CurriculumsService} from './CurriculumsService';
import {ProgramsNewService} from '../Program';
import {PlacementTestsService} from '../PlacementTest/PlacementTestsService';

const levelService = new LevelsService();
const curriculumsService = new CurriculumsService();
const programsService = new ProgramsNewService();
const placementTestsService = new PlacementTestsService();
const gradeService = new GradeService();

export const CurriculumCreate = () => {
  const history = useHistory();

  const {Title, Text} = Typography;

  const [isError, setIsError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const location: {
    state: any;
    hash: any;
    search: any;
    pathname: any;
  } = useLocation();

  const [curriculum, setCurriculum] = useState<CurriculumUI>();
  const [programs, setPrograms] = useState<Array<Program> | []>([]);
  const [selectedProgramId, setSelectedProgramId] = useState<string>();
  const [selectedLevelIds, setSelectedLevelIds] = useState<string[]>([]);
  const [selectedPlacementTestIds, setSelectedPlacementTestIds] = useState<
    string[]
  >([]);
  const [selectedCurriculumType, setSelectedCurriculumType] =
    useState<string>();
  const [selectedGradeIds, setSelectedGradeIds] = useState<string[]>([]);
  const [isPublished, setIsPublished] = useState<boolean>(false);
  const [isAcademic, setIsAcademic] = useState<boolean>(false);

  const [levels, setLevels] = useState<Array<LevelUI> | []>([]);
  const [placementTests, setPlacementTests] = useState<Array<any> | []>([]);
  const [gradesOptions, setGradesOptions] = useState<Array<any> | []>([]);

  useEffect(() => {
    levelService
      .getLevels()
      .then(lvls => {
        setLevels(lvls);
      })
      .catch(error => {
        setIsError(true);
        console.log('Error ->', error);
      });

    programsService
      .getNewPrograms()
      .then(resp => {
        setIsLoading(false);
        // console.log('getProgramsr response ->->', resp);
        setPrograms(resp);
      })
      .catch(error => {
        setIsError(true);
        console.log('Error ->', error);
      });

    placementTestsService
      .getPlacementTests(1, 100) // Fetch first 100 placement tests
      .then(resp => {
        setIsLoading(false);
        console.log('Placement tests response ->', resp);
        setPlacementTests(resp.items || []);
      })
      .catch(error => {
        setIsError(true);
        console.log('Error fetching placement tests ->', error);
      });

    gradeService
      .getGrades(100, 1)
      .then(resp => {
        console.log('Grades response ->', resp);
        setGradesOptions(resp.items || []);
      })
      .catch(error => {
        console.log('Error fetching grades ->', error);
      });
  }, []);

  const onChange = (prop: any, value: any) => {
    console.log('curre_curriculum', curriculum);
    //@ts-ignore
    setCurriculum({...curriculum, [prop]: value});
  };

  console.log('curriculum', curriculum);

  return (
    <div style={{padding: 10}}>
      <Title style={{textAlign: 'center'}}>Create Curriculum</Title>
      <>
        <Row>
          <Col span={12}>
            <div style={{margin: 20}}>
              <Text style={{display: 'block'}} strong={true}>
                Curriculum Name
              </Text>
              <Input
                placeholder={'Enter Curriculum Name'}
                onChange={e => onChange('name', e.target.value)}
                value={curriculum?.name}
              />
            </div>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <div style={{margin: 20}}>
              <Text style={{display: 'block'}} strong={true}>
                Curriculum Type *
              </Text>
              <Select
                value={selectedCurriculumType}
                showSearch
                style={{width: '100%'}}
                placeholder="Select Curriculum Type"
                optionFilterProp="children"
                onChange={type => {
                  setSelectedCurriculumType(type);
                  onChange('type', type);
                }}>
                {Object.values(CurriculumTypeEnum).map(type => (
                  <Select.Option key={type} value={type}>
                    {type}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <div style={{margin: 20}}>
              <Text style={{display: 'block'}} strong={true}>
                Select Curriculum Program *
              </Text>
              <Select
                value={selectedProgramId}
                showSearch
                style={{width: '100%'}}
                placeholder="Select a Program"
                optionFilterProp="children"
                onChange={programId => setSelectedProgramId(programId)}>
                {programs?.map(prgm => (
                  <Select.Option key={prgm.id} value={prgm.id!}>
                    {prgm.name}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
        </Row>

        {!isAcademic && (
          <Row>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Select Curriculum Levels *
                </Text>
                <Select
                  mode="multiple"
                  value={selectedLevelIds}
                  showSearch
                  style={{width: '100%'}}
                  placeholder="Select levels"
                  optionFilterProp="children"
                  onChange={levelIds => setSelectedLevelIds(levelIds)}>
                  {levels?.map(level => (
                    <Select.Option key={level.id} value={level.id}>
                      {level.name}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </Col>
          </Row>
        )}

        {isAcademic && (
          <Row>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Select Grades *
                </Text>
                <Select
                  mode="multiple"
                  value={selectedGradeIds}
                  showSearch
                  style={{width: '100%'}}
                  placeholder="Select grades"
                  optionFilterProp="children"
                  onChange={gradeIds => setSelectedGradeIds(gradeIds)}>
                  {gradesOptions?.map((grade: any) => (
                    <Select.Option key={grade._id} value={grade._id}>
                      {grade.name}{' '}
                      {grade.arabicName ? `(${grade.arabicName})` : ''}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </Col>
          </Row>
        )}

        <Row>
          <Col span={12}>
            <div style={{margin: 20}}>
              <Text style={{display: 'block'}} strong={true}>
                Select Placement Tests
              </Text>
              <div style={{display: 'flex', gap: 10}}>
                <Select
                  mode="multiple"
                  value={selectedPlacementTestIds}
                  showSearch
                  style={{flex: 1}}
                  placeholder="Select placement tests"
                  optionFilterProp="children"
                  onChange={testIds => setSelectedPlacementTestIds(testIds)}>
                  {placementTests?.map(test => (
                    <Select.Option
                      key={test._id || test.id}
                      value={test._id || test.id}>
                      {test.name}
                    </Select.Option>
                  ))}
                </Select>
                <Button
                  onClick={() => history.push('/placement-tests/create')}
                  type="default">
                  create
                </Button>
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col span={6}>
            <div style={{margin: 20}}>
              <Text style={{display: 'block', marginBottom: 8}} strong={true}>
                Is Published
              </Text>
              <Switch
                checked={isPublished}
                onChange={checked => setIsPublished(checked)}
                checkedChildren="Yes"
                unCheckedChildren="No"
              />
            </div>
          </Col>
          <Col span={6}>
            <div style={{margin: 20}}>
              <Text style={{display: 'block', marginBottom: 8}} strong={true}>
                Is Academic
              </Text>
              <Switch
                checked={isAcademic}
                onChange={checked => {
                  if (checked) {
                    Modal.confirm({
                      title: 'Switch to Academic Curriculum',
                      content:
                        'All selected levels will be removed. You will need to select at least one grade instead. Do you want to continue?',
                      okText: 'Yes, switch to Academic',
                      cancelText: 'Cancel',
                      onOk: () => {
                        setSelectedLevelIds([]);
                        setIsAcademic(true);
                      },
                    });
                  } else {
                    Modal.confirm({
                      title: 'Switch to Non-Academic Curriculum',
                      content:
                        'All selected grades will be removed. You will need to select at least one level instead. Do you want to continue?',
                      okText: 'Yes, switch to Non-Academic',
                      cancelText: 'Cancel',
                      onOk: () => {
                        setSelectedGradeIds([]);
                        setIsAcademic(false);
                      },
                    });
                  }
                }}
                checkedChildren="Yes"
                unCheckedChildren="No"
              />
            </div>
          </Col>
        </Row>
      </>

      <Button
        onClick={async () => {
          console.log('INCREATEEET');
          if (
            !curriculum ||
            !curriculum?.name ||
            !selectedCurriculumType ||
            !selectedProgramId
          ) {
            notification.warning({
              message: 'Missing Fields',
              description:
                'Please fill in all required fields (name, type, and program).',
            });
            return;
          }

          if (
            isAcademic &&
            (!selectedGradeIds || selectedGradeIds.length === 0)
          ) {
            notification.warning({
              message: 'Missing Grades',
              description:
                'Academic curriculums require at least one grade to be selected.',
            });
            return;
          }

          if (
            !isAcademic &&
            (!selectedLevelIds || selectedLevelIds.length === 0)
          ) {
            notification.warning({
              message: 'Missing Levels',
              description:
                'Non-academic curriculums require at least one level to be selected.',
            });
            return;
          }

          console.log('INCREATEEET_ID', curriculum);

          setIsLoading(true);

          // NEW IMPLEMENTATION - Using @PikaDoApp/npm-pikado-logic package
          await curriculumsService
            .createNewCurriculum(
              curriculum,
              selectedProgramId,
              selectedLevelIds,
              selectedCurriculumType as CurriculumTypeEnum,
              selectedPlacementTestIds,
              selectedGradeIds,
              isPublished,
              isAcademic,
            )
            .then((e: any) => {
              notification.success({
                message: 'Curriculum Created!',
                description: `"${curriculum.name}" has been created successfully.`,
                duration: 4,
              });
              history.push('/curriculums');
            })
            .catch(err => {
              notification.error({
                message: 'Creation Failed',
                description:
                  err?.message ||
                  'Failed to create curriculum. Please try again.',
                duration: 6,
              });

              console.log('upadate errpr curriculum->', err);
            })
            .finally(() => {
              setIsLoading(false);
            });
        }}>
        Create
      </Button>
    </div>
  );
};
